// @flow
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

export default graphql(
  gql`
    query getProposal($id: ID!) {
      proposal(id: $id) {
        id
        title
        content
        isOwnedByUser
      }
    }
  `,
  {
    name: 'getProposal',
    options: props => ({
      skip: !props.match.params.id,
      variables: {
        id: props.match.params.id,
      },
    }),
  }
);



// WEBPACK FOOTER //
// ./src/pages/proposal/graphql/get-proposal.js